(() => {
  const init = () => {
    document.querySelectorAll('[data-ky-cookie-open]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const promo = document.querySelector('[data-ky-promo-dialog]');
        if (promo?.open) promo.close();
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy controls unavailable');
          await window.privacyBanner.showPreferences();
        } catch {
          if (button.dataset.privacyUrl) location.assign(button.dataset.privacyUrl);
        }
      });
    });
    document.querySelectorAll('[data-ky-promo]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const dialog = root.querySelector('[data-ky-promo-dialog]');
      const trigger = root.querySelector('[data-ky-promo-open]');
      const storageKey = 'karakaya-deals-shown-v1';
      let seen = false, timer, previousFocus, previousOverflow = '';
      try { seen = sessionStorage.getItem(storageKey) === '1'; } catch {}
      const visible = element => element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none';
      const cookieVisible = () => [...document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,[data-shopify-privacy-banner]')].some(visible);
      const busy = () => document.visibilityState !== 'visible' || cookieVisible() || document.querySelector('dialog[open],cart-drawer.active,.ky-search.is-open') || document.activeElement?.matches('input,textarea,select');
      const open = () => {
        if (!dialog || dialog.open || busy()) return false;
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.documentElement.classList.add('ky-promo-open');
        document.body.style.overflow = 'hidden';
        seen = true;
        try { sessionStorage.setItem(storageKey, '1'); } catch {}
        return true;
      };
      const attempt = () => {
        if (!root.isConnected || seen || root.dataset.editor === 'true') return;
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy) { timer = setTimeout(attempt, 5000); return; }
        const consent = privacy.currentVisitorConsent();
        const awaitingConsent = privacy.shouldShowBanner() && ['analytics','marketing','preferences'].every(key => !consent[key]);
        if (awaitingConsent || !open()) timer = setTimeout(attempt, 5000);
      };
      trigger?.addEventListener('click', open);
      root.querySelectorAll('[data-ky-promo-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog?.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
      dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('ky-promo-open');
        document.body.style.overflow = previousOverflow;
        if (previousFocus?.isConnected && previousFocus.getClientRects().length) previousFocus.focus({preventScroll:true});
      });
      const delay = Math.max(10, Number(root.dataset.delay) || 20) * 1000;
      timer = setTimeout(attempt, delay);
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], () => {});
      const unload = event => {
        if (!event.target.contains(root)) return;
        clearTimeout(timer);
        if (dialog?.open) dialog.close();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
